export default "__VITE_ASSET__L34cFMeS__"